import React from 'react';
import PropTypes from 'prop-types';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Col from '@zg-rentals/multibrand-ui/lib/Col';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Button from '@zg-rentals/multibrand-ui/lib/Button';

export default class InquiryContactThanks extends React.Component {
    static propTypes = {
        name: PropTypes.string,
        type: PropTypes.string,
        address: PropTypes.string,
        deactivationUri: PropTypes.string,
    };

    static defaultProps = {
        name: '',
        address: '',
        type: 'default',
        deactivationUri: '',
    };

    constructor() {
        super();
        this.onHandleClickDeactivate = this.onHandleClickDeactivate.bind(this);
        this.onHandleClickBackToProperties = this.onHandleClickBackToProperties.bind(this);
    }

    onHandleClickBackToProperties(e) {
        e.preventDefault();

        window.router.transitionTo('/rental-manager/properties');
    }

    onHandleClickDeactivate(e) {
        const { deactivationUri, saveIntention } = this.props;
        e.preventDefault();

        saveIntention('deactivateListing');
        window.router.transitionTo(deactivationUri);
    }

    renderType() {
        const { name, address, type } = this.props;
        const defaultText = `We'll let ${name} know for you.`;
        const deactivateText = `Shall we go ahead and deactivate your listing for ${address}?`;

        switch (type) {
            case 'deactivate':
                return (
                    <React.Fragment>
                        <Text className="stacked-lg">{deactivateText}</Text>
                        <Button type="primary" onClick={this.onHandleClickDeactivate}>
                            Yes, deactivate listing
                        </Button>
                    </React.Fragment>
                );
            default:
                return (
                    <React.Fragment>
                        <Text className="stacked-lg">{defaultText}</Text>
                        <Button type="primary" onClick={this.onHandleClickBackToProperties}>
                            Back to my properties
                        </Button>
                    </React.Fragment>
                );
        }
    }

    render() {
        return (
            <React.Fragment>
                <Row>
                    <Col>
                        <Text type="h2">All set, thanks for your help</Text>
                    </Col>
                </Row>
                <Row>
                    <Col>{this.renderType()}</Col>
                </Row>
            </React.Fragment>
        );
    }
}
